export function serviceBase() {
  return function superCharge(serviceInstance) {
    return serviceInstance;
  };
}

export default serviceBase();
